import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Calendar, MapPin, ExternalLink } from 'lucide-react';
import { useSectionData } from '../hooks/useSectionData';
import { fetchConferences, attr } from '../services/api';

function fmtDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
}

const ROLE_LABELS = {
  presenter:  'Presenter',
  attendee:   'Attendee',
  organizer:  'Organizer',
  panelist:   'Panelist',
};

export default function Conferences() {
  const items = useSectionData(fetchConferences);
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });

  if (!items) return null;

  return (
    <section id="conferences" ref={ref} className={`section${inView ? ' visible' : ''}`}>
      <div className="container">
        <header className="section-header">
          <p className="section-label">conferences</p>
          <h2 className="section-title">Conferences</h2>
          <div className="section-line" />
        </header>

        <div className="events-grid">
          {items.map((item, i) => {
            const a = attr(item);
            return (
              <div key={i} className="event-card">
                <p className="event-name">{a.name}</p>
                {a.role && (
                  <p className="event-role">{ROLE_LABELS[a.role] || a.role}</p>
                )}
                <div className="event-meta">
                  {a.date && (
                    <span><Calendar size={11} /> {fmtDate(a.date)}</span>
                  )}
                  {a.location && (
                    <span><MapPin size={11} /> {a.location}</span>
                  )}
                </div>
                {a.topic && <p className="event-desc">{a.topic}</p>}
                {a.description && <p className="event-desc">{a.description}</p>}
                {a.url && (
                  <a
                    href={a.url}
                    target="_blank"
                    rel="noreferrer noopener"
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: '0.8rem', color: 'var(--accent)', marginTop: 6 }}
                  >
                    <ExternalLink size={12} /> Learn More
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
